import React from "react";

import HeroImage from "../hero/HeroImage";

const Newsletter = ({ children }) => (
  <div className="hero pt-0">
    <HeroImage
      bgColor="bg-deep-black"
      imagePath="/images/home/mood/"
      altText="Handshake im Büro"
    />
    <div className="page-container flex justify-center items-center h-full">
      <div className="newsletter">{children}</div>
    </div>
  </div>
);

export default Newsletter;
